import React, { useState, useEffect, FormEvent, ChangeEvent } from 'react';
import { configData2 } from './ConfigComponents';
import "./ConfigForm.css"
import { openPopup } from '../../stateManagement/actions/popupActions';
import { IconButton, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import RenderSvg from '../renderSvg/RenderSvg';
import { useNavigate } from 'react-router-dom';
import UISectionModal from './UISectionModal';

interface SubSection {
    sectionHeading: string;
    inputFields: InputField[];
}

interface InputField {
    child: any;
    name: string;
}

interface ConfigCardProps {
    activeOptionKey: any
}

const ConfigForm: React.FC<ConfigCardProps> = ({ activeOptionKey }) => {
    const navigate = useNavigate();
    const [domainType, setDomainType] = useState<string>("");
    const [heading, setHeading] = useState<string>("");
    const [importValue, setImportValue] = useState<boolean>(false);
    const [subSections, setSubSections] = useState<SubSection[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const LOCAL_STORAGE_KEY = 'configData';
    const storedDataString = localStorage.getItem(LOCAL_STORAGE_KEY) || configData2;
    let configData: any;
    var storedData = typeof storedDataString === 'string' ? JSON.parse(storedDataString) : storedDataString;
    useEffect(() => {
        configData = storedData?.[activeOptionKey];
        setDomainType(configData?.domainType || "");
        setHeading(configData?.heading || "");
        setImportValue(configData?.import || false);
        setSubSections(configData?.subSections);
    }, [activeOptionKey]);



    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        const previousConfigData = storedData?.[activeOptionKey] || {};
        const { domainType: previousDomainType, heading: previousHeading, import: previousImportValue, configurations: previousConfigurations } = previousConfigData;

        const formData = {
            configurations: previousConfigurations,
            domainType: previousDomainType,
            heading: previousHeading,
            import: previousImportValue,
            subSections: subSections.map(section => ({
                sectionHeading: section.sectionHeading,
                inputFields: section.inputFields.map(field => ({
                    ...field
                }))
            })),
        };
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ ...storedData, [activeOptionKey]: formData }));
        openPopup('Success', `Saved Successfully`);
    };

    const deleteSection = (sectionIndex: number) => {
        const updatedSubSections = [...subSections];
        updatedSubSections.splice(sectionIndex, 1);
        setSubSections(updatedSubSections);
    };

    const handleDragEnd = (result: any) => {
        const { source, destination, type } = result;
        if (!destination) return;
        if (type === 'section') {
            const updatedSections = Array.from(subSections);
            const [reorderedSection] = updatedSections.splice(source.index, 1);
            updatedSections.splice(destination.index, 0, reorderedSection);
            setSubSections(updatedSections);
        }
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleSaveSection = (sectionHeading: string) => {
        // console.log("configData", storedData?.[activeOptionKey])
        const updatedConfigData = {
            ...storedData?.[activeOptionKey],
            subSections: [
                ...storedData?.[activeOptionKey].subSections,
                {
                    sectionHeading,
                    inputFields: []
                }
            ]
        };

        storedData[activeOptionKey] = updatedConfigData;
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storedData));
        handleCloseModal();
        navigate("/dashboard/uiConfigDashboard/editUiConfigDashboard", { state: { data: activeOptionKey, sectionName: sectionHeading } });
    };


    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            <form className="form-container" onSubmit={handleSubmit}>
                <div className="form-top">
                    <h2>{heading}</h2>
                    <button className="uiButton" type="button" onClick={handleOpenModal}>Add Section</button>
                </div>

                <div className='section-top'>
                    <TextField size='small' value={domainType} label="Domain Type" onChange={(e) => setDomainType(e.target.value)} InputProps={{ readOnly: true }} variant="filled" />
                    <TextField size='small' value={heading} label="Heading" onChange={(e) => setHeading(e.target.value)} variant="filled" />
                    <span
                        style={{
                            fontSize: "1.1rem",
                            display: "inline-flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                        }}
                    >
                        <label className="custom-checkbox-label">
                            <input
                                type="checkbox"
                                className="custom-checkbox-input"
                                checked={importValue}
                                onChange={(e) => setImportValue(e.target.checked)}
                            />
                            <span
                                className={`custom-checkbox-span ${importValue ? 'checked' : ''}`}
                            ></span>
                            Import
                        </label>
                    </span>


                </div>

                <Droppable droppableId="droppable-sections" type="section">
                    {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                            {subSections.map((section, index) => (
                                <Draggable key={index} draggableId={`section-${index}`} index={index}>
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <div className="section" key={index}>
                                                <div className="sectionHeading">
                                                    <h3>{`Section ${index + 1} (${section.sectionHeading})`} </h3>
                                                    <div className='input-end'>
                                                        <FontAwesomeIcon
                                                            onClick={() => deleteSection(index)}
                                                            className="footer_config_plus_icon"
                                                            icon={faTrash}
                                                        />
                                                        <IconButton
                                                            size="small"
                                                            className="validateCollapseToggleBtn"
                                                            onClick={() => { navigate("/dashboard/uiConfigDashboard/editUiConfigDashboard", { state: { data: activeOptionKey, sectionName: section.sectionHeading } }); }}
                                                        >
                                                            <RenderSvg name="Reset-password" />
                                                        </IconButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>

                <button className="uiButton" type="submit">Submit</button>
                <UISectionModal
                    activeOptionKey={activeOptionKey}
                    open={isModalOpen}
                    handleClose={handleCloseModal}
                    handleSave={handleSaveSection}
                />
            </form>
        </DragDropContext>

    );
};

export default ConfigForm;
